import { ApiService } from 'services';

import { handleException } from 'actions/exceptions';

export const GET_JURISDICTIONS_SUCCESS = 'GET_JURISDICTIONS_SUCCESS';
export const GET_JURISDICTIONS_FAILURE = 'GET_JURISDICTIONS_FAILURE';

function receive(jurisdictions) {
  return {
    type: GET_JURISDICTIONS_SUCCESS,
    jurisdictions
  };
}

function reject() {
  return {
    type: GET_JURISDICTIONS_FAILURE
  };
}

export function getJurisdictions() {
  return (dispatch) => {
    const promise = () => ApiService
      .getJurisdictions()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
